import { MasterTranslation } from '@/constants';
import { useGlobalState } from '@/hooks';
import type { FC } from 'react';
import {
  EmailVerificationWrapper,
  VerificationEmail,
  VerificationSubtext,
  VerificationTitle,
} from './EmailVerification.styles';

const EmailVerification: FC = () => {
  const { userInfo, t } = useGlobalState();

  const translatedText = {
    title: t(MasterTranslation.VerificationMainText),
    subtext: t(MasterTranslation.VerificationSubText),
  };

  return (
    <EmailVerificationWrapper>
      <VerificationTitle>{translatedText.title}</VerificationTitle>
      <VerificationSubtext>{translatedText.subtext}</VerificationSubtext>
      <VerificationEmail>{userInfo?.email}</VerificationEmail>
    </EmailVerificationWrapper>
  );
};

export default EmailVerification;
